import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import FormInput from '../../../shared/components/ui/FormInput';
import Button from '../../../shared/components/ui/Button';
import { getAllAccommodationsByProject } from '../../services/api/implementation/impl';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

export const UpdateExtraCharges = ({ extraCharge, updateSuccess, onClose }) => {
  const userId = Cookies.get('userId');
  const { id: projectId } = useParams();
  const [selectedAccommodationType, setSelectedAccommodationType] = useState('GROUP');
  const [accommodations, setAccommodations] = useState([]);
  const [selectedAccommodationIds, setSelectedAccommodationIds] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [removingId, setRemovingId] = useState(null);

  console.log(extraCharge);

  // Get accommodation type from the first accommodation in the list
  useEffect(() => {
    if (extraCharge.accomodations && extraCharge.accomodations.length > 0) {
      const firstAccommodation = extraCharge.accomodations[0];
      if (firstAccommodation.accomodation?.accomodationType) {
        setSelectedAccommodationType(firstAccommodation.accomodation.accomodationType);
      }
    }
  }, [extraCharge]);


  // Fetch accommodations based on selected type
  const { data: accommodationData } = useQuery({
    queryKey: ['accommodations', projectId],
    queryFn: () =>
      // getAllAccommodationsByProject(projectId, `&accomodationType=${selectedAccommodationType}`),
      getAllAccommodationsByProject(projectId),
    enabled: !!projectId
  });

  // Update accommodations list when data changes
  useEffect(() => {
    if (accommodationData) {
      const accommodationOptions = accommodationData?.map((acc) => ({
        value: acc.id.toString(),
        label: acc.name
      }));
      setAccommodations(accommodationOptions);
    }
  }, [accommodationData]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll('[data-dropdown]');
      let clickedInside = false;

      dropdowns.forEach((dropdown) => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const { register, handleSubmit, setValue, watch, reset } = useForm({
    defaultValues: {
      name: '',
      description: '',
      price: '',
      gst: '',
      isMandatory: true,
      mode: ''
    }
  });

  const isMandatoryValue = watch('isMandatory');

  // Reset form and selections when extraCharge changes (e.g. opening edit for a charge)
  useEffect(() => {
    if (!extraCharge?.id) return;
    const gstVal = extraCharge.gst;
    const gstStr =
      gstVal != null && gstVal !== ''
        ? Number(gstVal).toFixed(2)
        : '';
    reset({
      name: extraCharge.name || '',
      description: extraCharge.description || '',
      price: extraCharge.price ?? '',
      gst: gstStr,
      isMandatory: extraCharge.isMandatory !== false,
      mode: extraCharge.mode || ''
    });
    if (extraCharge.accomodations?.length > 0) {
      setSelectedAccommodationIds(
        extraCharge.accomodations.map((acc) => String(acc.accomodation_id))
      );
    } else {
      setSelectedAccommodationIds([]);
    }
  }, [extraCharge?.id, extraCharge?.name, extraCharge?.description, extraCharge?.price, extraCharge?.gst, extraCharge?.isMandatory, extraCharge?.mode, extraCharge?.accomodations, reset]);

  const handleAccommodationTypeChange = (e) => {
    const newType = e.target.value;
    setSelectedAccommodationType(newType);
    // Clear selected accommodations when type changes
    setSelectedAccommodationIds([]);
  };

  const handleAccommodationSelection = (accommodationId) => {
    console.log('Accommodation selection:', accommodationId, 'from:', selectedAccommodationIds);

    if (selectedAccommodationIds.includes(accommodationId)) {
      // Removing accommodation
      setRemovingId(accommodationId);
      setTimeout(() => {
        setSelectedAccommodationIds((prev) => {
          const filtered = prev.filter((id) => id !== accommodationId);
          console.log('Updated list after removal:', filtered);
          return filtered;
        });
        setRemovingId(null);
      }, 150); // Small delay for visual feedback
    } else {
      // Adding accommodation
      setSelectedAccommodationIds((prev) => {
        const added = [...prev, accommodationId];
        console.log('Added accommodation, new list:', added);
        return added;
      });
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const onSubmit = (data) => {
    // Track update action
    mixpanel.track('Extra Charge Update Submitted', {
      user_id: userId,
      extra_charge_id: extraCharge.id,
      timestamp: new Date().toISOString()
    });

    const formattedData = {
      name: data.name,
      description: data.description,
      price: parseFloat(data.price),
      gst: data.gst !== '' ? parseFloat(Number(data.gst).toFixed(2)) : undefined,
      isMandatory: data.isMandatory === true || data.isMandatory === 'true',
      mode: data.mode,
      accommodation_ids: selectedAccommodationIds
    };
    updateSuccess({ id: extraCharge.id, payload: formattedData });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <FormInput
          width={100}
          label="Pricing Type"
          type="text"
          readOnly={true}
          register={register}
          register_key="mode"
          valuePre={
            extraCharge.mode === 'accommodation'
              ? 'Accommodation'
              : extraCharge.mode === 'sqft'
                ? 'sqft'
                : extraCharge.mode === 'sqmt'
                  ? 'sqmt'
                  : ''
          }
        />
        {/* <FormInput
          width={100}
          label="Accommodation Type"
          type="dropdown"
          readOnly={false}
          register={register}
          register_key="accomodation_type"
          dropdownOptions={['GROUP', 'INDEPENDENT', 'PARKING']}
          valuePre={selectedAccommodationType}
          onChange={handleAccommodationTypeChange}
          isRequired={true}
        /> */}

        <div className="flex flex-col gap-2">
          <label className="block text-sm font-medium">Select Accommodations</label>
          <div className="relative" data-dropdown>
            <div
              className="p-2 border rounded cursor-pointer flex items-center justify-between"
              onClick={toggleDropdown}>
              <span
                className={selectedAccommodationIds.length > 0 ? 'text-gray-900' : 'text-gray-500'}>
                {selectedAccommodationIds.length > 0
                  ? `${selectedAccommodationIds.length} accommodation(s) selected`
                  : 'Select Accommodations'}
              </span>
              <svg
                className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>

            {isDropdownOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-y-auto">
                {accommodations.map((acc) => (
                  <label
                    key={acc.value}
                    className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedAccommodationIds.includes(acc.value)}
                      onChange={() => handleAccommodationSelection(acc.value)}
                      className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      onClick={(e) => e.stopPropagation()}
                    />
                    <span className="text-sm text-gray-700">{acc.label}</span>
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Display selected accommodations */}
          {selectedAccommodationIds.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {selectedAccommodationIds.map((selectedId) => {
                const selectedAcc = accommodations.find((acc) => acc.value === selectedId);
                return selectedAcc ? (
                  <div
                    key={selectedId}
                    className="flex items-center gap-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                    <span>{selectedAcc.label}</span>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleAccommodationSelection(selectedId);
                      }}
                      className={`text-blue-600 hover:text-blue-800 hover:bg-blue-200 rounded-full w-5 h-5 flex items-center justify-center text-sm font-bold transition-all duration-200 ${
                        removingId === selectedId ? 'bg-red-200 text-red-600 scale-110' : ''
                      }`}
                      title="Remove accommodation"
                      disabled={removingId === selectedId}>
                      {removingId === selectedId ? '✓' : '×'}
                    </button>
                  </div>
                ) : null;
              })}
            </div>
          )}
        </div>

        <FormInput
          width={100}
          label="Extra Charge Name"
          register={register}
          register_key="name"
          type="text"
          isRequired={true}
        />

        <FormInput
          width={100}
          label="Description (Optional)"
          register={register}
          register_key="description"
          type="text"
          isRequired={false}
        />

        <FormInput
          width={100}
          label={`Price ${extraCharge.mode ? `(${extraCharge.mode === 'accommodation' ? 'Accommodation' : extraCharge.mode === 'sqft' ? 'sqft' : extraCharge.mode === 'sqmt' ? 'sqmt' : ''})` : ''}`}
          register={register}
          register_key="price"
          type="number"
          isRequired={true}
        />

        <FormInput
          width={100}
          label="GST (%)"
          register={register}
          register_key="gst"
          type="number"
          isRequired={false}
          placeholder="0.00"
        />

        <div className="flex flex-col gap-2">
          <label className="block text-sm font-medium">Is compulsory</label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                {...register('isMandatory')}
                value={true}
                checked={isMandatoryValue === true}
                onChange={() => setValue('isMandatory', true)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="text-sm">Yes</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                {...register('isMandatory')}
                value={false}
                checked={isMandatoryValue === false}
                onChange={() => setValue('isMandatory', false)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="text-sm">No</span>
            </label>
          </div>
        </div>
      </div>

      <div className="flex justify-end items-center space-x-4 mt-4">
        <Button type="button" onClick={onClose} displayType="secondary">
          Cancel
        </Button>
        <Button type="submit">Update</Button>
      </div>
    </form>
  );
};
